import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

const testimonials = [
  {
    name: '李明',
    role: '影视爱好者',
    content:
      '福利视频网站是我每天必上的追剧平台，资源更新速度真的很快，画质清晰，而且完全免费。推荐给所有喜欢看剧的朋友！',
    rating: 5,
  },
  {
    name: '王芳',
    role: '综艺达人',
    content:
      '这里的综艺资源太全了，很多在其他平台找不到的节目这里都有。分类清晰、搜索方便，使用体验非常好。',
    rating: 5,
  },
  {
    name: '张伟',
    role: '动漫迷',
    content:
      '作为动漫爱好者，福利视频网站的动漫资源库让我惊喜。从经典老番到最新番剧，高清画质在线看，太赞了。',
    rating: 5,
  },
  {
    name: '陈静',
    role: '电影达人',
    content:
      '电影分类做得很好，国内外大片一应俱全。最棒的是没有烦人的广告，观影体验非常流畅，强烈推荐。',
    rating: 4,
  },
  {
    name: '刘洋',
    role: '纪录片爱好者',
    content:
      '纪录片的更新速度和质量都令人满意。自然、人文、科技各类纪录片都有，是我学习充电的好去处。',
    rating: 5,
  },
  {
    name: '赵雪',
    role: '家庭用户',
    content:
      '全家人都在用这个网站，孩子看动漫、我们追剧、老人看纪录片，各取所需。资源丰富，操作简单，全家好评。',
    rating: 5,
  },
];

const faqs = [
  {
    question: '福利视频网站真的完全免费吗？',
    answer:
      '是的，福利视频网站承诺永久免费。我们的所有视频资源都可以免费在线观看，无需注册会员，无需支付任何费用。我们通过广告合作维持网站运营，不影响用户的观影体验。',
  },
  {
    question: '视频画质如何？有没有高清资源？',
    answer:
      '我们提供多种画质选择，包括高清（720P）、全高清（1080P）以及部分资源的超高清（4K）画质。用户可以根据自己的网络状况和设备选择合适的画质进行观看。',
  },
  {
    question: '需要注册才能观看视频吗？',
    answer:
      '不需要！福利视频网站的核心优势之一就是无需注册即可畅享所有视频资源。您可以直接打开网站，选择喜欢的视频立即观看，没有任何门槛。',
  },
  {
    question: '视频更新频率是怎样的？',
    answer:
      '我们每天都会更新200+部视频资源，确保用户能够第一时间观看到最新的影视内容。热门电视剧和综艺节目通常会在播出后数小时内完成更新。',
  },
  {
    question: '支持哪些设备观看？',
    answer:
      '福利视频网站采用响应式设计，支持电脑、平板、手机等多种设备。您可以在任何支持现代浏览器的设备上流畅观看视频，获得一致的优质体验。',
  },
  {
    question: '如果遇到播放问题怎么办？',
    answer:
      '如果您在使用过程中遇到任何问题，可以通过本页面的联系表单与我们取得联系。我们的客服团队会在24小时内为您提供帮助。同时建议您尝试切换画质或更换浏览器来解决常见的播放问题。',
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    document.title = '关于我们 - 福利视频网站 | 品牌介绍与联系方式';
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');

    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setFormStatus('success');
      return;
    }

    setFormStatus('submitting');
    setFormError('');

    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9qo6gfnahb7382ovcog', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string };

      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (
        response.ok &&
        parsed?.code === 'OK' &&
        !serverMsg.includes('spam') &&
        !serverMsg.includes('form data is spam')
      ) {
        setFormStatus('success');
        form.reset();
      } else {
        setFormStatus('error');
        setFormError(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setFormStatus('error');
      setFormError('网络异常，请检查网络连接后重试');
    }
  };

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="bg-background-100 border-b border-background-200/70">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
          </div>

          <section className="max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <div className="text-center mb-10">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 mb-4">
                <i className="ri-play-fill text-3xl text-primary-500"></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                关于福利视频网站
              </h1>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                福利视频网站是一家致力于为全球华语用户提供免费高清视频资源的在线平台。我们汇聚海量影视、综艺、动漫、纪录片等内容，让每一位用户都能轻松享受高品质的观影体验。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
              <div className="bg-background-100 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 mb-3">
                  <i className="ri-eye-line text-xl text-primary-500"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-900 mb-2">我们的使命</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  打破信息壁垒，让优质视频内容触手可及，为每一位用户提供免费、便捷、高品质的观影服务。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 mb-3">
                  <i className="ri-team-line text-xl text-accent-500"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-900 mb-2">我们的团队</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  由一群热爱视频内容的专业人士组成，日以继夜地为用户筛选和更新最优质的视频资源。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-100 mb-3">
                  <i className="ri-shield-check-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-900 mb-2">品质承诺</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  所有视频资源均经过严格的质量审核，确保画质清晰、播放流畅，为用户提供最佳观影体验。
                </p>
              </div>
            </div>
          </section>

          <section className="bg-background-100 py-10 md:py-14">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-8">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {testimonials.map((t, index) => (
                  <div key={index} className="bg-background-50 rounded-xl p-5">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <div key={i} className="w-4 h-4 flex items-center justify-center">
                          <i
                            className={`${
                              i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-fill text-background-300'
                            } text-sm`}
                          ></i>
                        </div>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                      {t.content}
                    </p>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                        <span className="text-xs font-bold text-primary-600">{t.name[0]}</span>
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-foreground-800">{t.name}</div>
                        <div className="text-xs text-foreground-400">{t.role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-14" id="contact">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们。也可以填写右侧表单，我们会在24小时内回复。
                </p>

                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 shrink-0">
                      <i className="ri-mail-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">电子邮箱</div>
                      <div className="text-sm text-foreground-500">contact@fulishipin.com</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 shrink-0">
                      <i className="ri-phone-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">客服电话</div>
                      <div className="text-sm text-foreground-500">400-888-9999</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 shrink-0">
                      <i className="ri-map-pin-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">公司地址</div>
                      <div className="text-sm text-foreground-500">北京市朝阳区光华路88号 福利视频大厦</div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="bg-background-100 rounded-xl p-6">
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">
                    发送消息
                  </h3>
                  <form
                    data-readdy-form
                    id="contact-form"
                    onSubmit={handleSubmit}
                    className="space-y-4"
                  >
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        您的姓名
                      </label>
                      <input
                        type="text"
                        id="contact-name"
                        name="name"
                        required
                        className="w-full px-3 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-800 focus:outline-none focus:border-primary-300 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        电子邮箱
                      </label>
                      <input
                        type="email"
                        id="contact-email"
                        name="email"
                        required
                        className="w-full px-3 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-800 focus:outline-none focus:border-primary-300 transition-colors"
                        placeholder="请输入您的电子邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        主题
                      </label>
                      <input
                        type="text"
                        id="contact-subject"
                        name="subject"
                        className="w-full px-3 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-800 focus:outline-none focus:border-primary-300 transition-colors"
                        placeholder="请输入消息主题"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        消息内容
                      </label>
                      <textarea
                        id="contact-message"
                        name="message"
                        required
                        maxLength={500}
                        rows={4}
                        className="w-full px-3 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-800 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                        placeholder="请输入您的消息内容（500字以内）"
                      ></textarea>
                    </div>

                    <input
                      type="text"
                      name="phone_alt"
                      className="honeypot-field"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />

                    {formStatus === 'success' && (
                      <div className="flex items-center gap-2 px-4 py-3 rounded-lg bg-green-50 text-sm text-green-700">
                        <div className="w-4 h-4 flex items-center justify-center shrink-0">
                          <i className="ri-check-line"></i>
                        </div>
                        消息发送成功！感谢您的联系，我们会尽快回复。
                      </div>
                    )}

                    {formStatus === 'error' && (
                      <div className="flex items-center gap-2 px-4 py-3 rounded-lg bg-red-50 text-sm text-red-700">
                        <div className="w-4 h-4 flex items-center justify-center shrink-0">
                          <i className="ri-error-warning-line"></i>
                        </div>
                        {formError}
                      </div>
                    )}

                    <button
                      type="submit"
                      disabled={formStatus === 'submitting'}
                      className="w-full px-4 py-2.5 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {formStatus === 'submitting' ? '发送中...' : '发送消息'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>

          <section className="bg-background-100 py-10 md:py-14">
            <div className="max-w-3xl mx-auto px-4 md:px-6">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-8">
                常见问题
              </h2>
              <div className="space-y-3">
                {faqs.map((faq, index) => (
                  <details key={index} className="group bg-background-50 rounded-xl overflow-hidden">
                    <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer select-none">
                      <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{faq.question}</span>
                      <div className="w-5 h-5 flex items-center justify-center shrink-0 transition-transform group-open:rotate-180">
                        <i className="ri-arrow-down-s-line text-foreground-500"></i>
                      </div>
                    </summary>
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于福利视频网站',
            description:
              '福利视频网站是一家致力于为全球华语用户提供免费高清视频资源的在线平台。',
            url: 'https://fulishipin.com/about',
            mainEntity: {
              '@type': 'Organization',
              name: '福利视频网站',
              url: 'https://fulishipin.com',
              contactPoint: {
                '@type': 'ContactPoint',
                telephone: '400-888-9999',
                contactType: 'customer service',
                availableLanguage: ['Chinese'],
              },
              address: {
                '@type': 'PostalAddress',
                addressLocality: '北京',
                addressRegion: '朝阳区',
                streetAddress: '光华路88号',
                addressCountry: 'CN',
              },
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </>
  );
}